import { render } from "./WareHouseSavePage.vue?vue&type=template&id=a80a46cc"
import script from "./WareHouseSavePage.vue?vue&type=script&lang=js"
export * from "./WareHouseSavePage.vue?vue&type=script&lang=js"
script.render = render

export default script